import {
  IIkCardSelectableIconItem
} from '@infomaniak/angular-common/src/components/ik-card-selectable-icon-item/ik-card-selectable-icon-item.interfaces';
import { translate } from '@ngneat/transloco';

export function getClientIkCardSelectableIconItemForManageProductLimited(): IIkCardSelectableIconItem {
  return {
    icon: 'icon-product-gestion',
    title: translate('Gestion limitee des produits'),
    description: translate('Le partenaire ne pourra acceder qu\'aux produits que vous autoriserez.'),
  };
}
